import * as types from "./responderExigencia.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  tokenRecaptcha: "",
  ShowModalDocumento: false,
  ShowModalExigencia: false,
  HeaderExigencia: {},
  ModalExigencia: {},
  ShowGridExigencia: undefined,
  DataGridExigencia: [],
  FormExigencia: {
    IdAnalise: undefined,
    ExigenciaDocumento: undefined,
    TipoDocumento: undefined,
    Exigencia: undefined,
    Motivo: undefined,
    Resposta: undefined,
    IdDocumento: undefined,
    DataGridDocumento: []
  },
});

const reduce = (state = initialState, action = {}) => {
  const { payload } = action;
  switch (action.type) {
    case types.SET_TOKEN_RECAPTCHA:
      return state.merge({ tokenRecaptcha: payload });
    case types.SET_HEADER_EXIGENCIA:
      return state.merge({ HeaderExigencia: payload });
    case types.TOGGLE_MODAL_DOCUMENTO:
      return state.merge({ ShowModalDocumento: !state.ShowModalDocumento })
    case types.TOGGLE_MODAL_EXIGENCIA:
      return state.merge({ ShowModalExigencia: !state.ShowModalExigencia })
    case types.SET_SHOW_GRID_EXIGENCIA:
      return state.merge({ ShowGridExigencia: payload });
    case types.SET_DATA_GRID_EXIGENCIA:
      return state.merge({ DataGridExigencia: payload });
    case types.SET_MODAL_EXIGENCIA:
      return state.merge({ ModalExigencia: payload });
    case types.SET_FORM_EXIGENCIA:
      return state.merge({
        FormExigencia: {
          ...state.FormExigencia,
          ...payload,
        },
      });
    case types.RESET_FORM:
      return initialState;
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule("redeSIM.responderExigencia", reduce);
